import { render, staticRenderFns } from "./DetailBlog.vue?vue&type=template&id=38fb823e&scoped=true"
import script from "./DetailBlog.vue?vue&type=script&lang=js"
export * from "./DetailBlog.vue?vue&type=script&lang=js"
import style0 from "./detailBlog.css?vue&type=style&index=0&id=38fb823e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb823e",
  null
  
)

export default component.exports